<!--已评论列表-->
<template>
  <div>
    <div class="in_list" v-for="(val,key) in stay" :key="key">
      <van-image round  width="0.8rem" height="0.8rem"  src="https://maximum_api.bei-lin.cn/wechat_oa/1.png"/>
      <van-row class="right">
        <van-col span="5">Acheng</van-col>
        <van-col span="12">2019-10-10</van-col>
        <van-col span="24" style="margin:10px 0" >周年快到了</van-col>
      </van-row>
        <oilTemplate :data="val"/>
      </div>
  </div>
</template>
<style lang="scss" scoped>
 .in_list {
  padding: 15px;
  background: #fff;
  .comment {
    margin: 10px 0;
    padding-left: 27px;
    font-size: 13px;
    color:#333;
  }
  }
  .right {
    width: calc(100% - 50px);
    float: right;
  }
</style>
<script>
import oilTemplate from '@/components/site/site_template'
export default {
  name: 'commlist',
  components: {oilTemplate},
  data () {
    return {
      stay: [
        {
          km: 11,
          msg: {
            image: {
              url: 'http://maximum_api.bei-lin.cn/files/121_1593607611_893.jpg'
            },
            show_pho: '0760-86694266',
            add: '珠海市香州区敬业路'
          },
          name: '珠海贝林测试',
          score: {
            score: 5,
            star: 5
          }
        },
        {
          km: 11,
          msg: {
            image: {
              url: 'http://maximum_api.bei-lin.cn/files/121_1593607611_893.jpg'
            },
            show_pho: '0760-86694266',
            add: '珠海市香州区敬业路'
          },
          name: '珠海贝林测试',
          score: {
            score: 5,
            star: 5
          }
        }
      ]
    }
  },
  mounted () {
    this.$root.loadingAll = false
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stay/commlist.vue